'use client'

import { useEffect } from 'react'
import { usePathname, useSearchParams } from 'next/navigation'
import { isAnalyticsDomainAllowed } from './domainGuard'
import { syncInternalTrafficFromQuery } from './internalTraffic'
import { applyInternalTrafficConfig, trackPageView } from './tracking'

export function useGoogleAnalytics() {
  const pathname = usePathname()
  const searchParams = useSearchParams()

  useEffect(() => {
    if (!isAnalyticsDomainAllowed()) return
    const internalParam = searchParams?.get('internal')
    syncInternalTrafficFromQuery(internalParam)
    applyInternalTrafficConfig()
  }, [searchParams])

  useEffect(() => {
    if (!isAnalyticsDomainAllowed()) return
    if (pathname) {
      const url =
        pathname +
        (searchParams?.toString() ? `?${searchParams.toString()}` : '')
      trackPageView(url)
    }
  }, [pathname, searchParams])
}
